var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('font-awesome-icon',{staticClass:"fa",attrs:{"icon":['far','check-circle']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }